<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off" #form>
  <div nz-row [nzGutter]="['0','0']">

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Mã</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Bắt buộc nhập mã">
          <input nz-input formControlName="typeOfPersonnelCode" name="maCS" type="text" placeholder="Nhập mã"
            [jAutofocus]>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="tenCS" nzRequired>Loại nhân sự</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Bắt buộc nhập tên loại nhân sự">
          <input nz-input formControlName="typeOfPersonnelName" name="tenCs" type="text"
            placeholder="Nhập loại nhân sự">
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label #label nzSpan="24" nzFor="formType" nzRequired>Form mẫu nhập liệu</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Bắt buộc chọn form mẫu nhập liệu">
          <nz-radio-group formControlName="formType">
            <label nz-radio [nzValue]="1">Cán bộ quản lý</label>
            <label nz-radio [nzValue]="2">Giáo viên/ nhân viên</label>
            <label nz-radio [nzValue]="3">Nhân viên hỗ trợ</label>
            <label nz-radio [nzValue]="4">Nhân viên trị liệu</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="displayOrder">Số thứ tự</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Bắt buộc nhập số thứ tự">
          <nz-input-number nz-input formControlName="displayOrder" type="text" placeholder="Nhập số thứ tự">
          </nz-input-number>
        </nz-form-control>
      </nz-form-item>
    </div>
    <!-- <div nz-col nzSm="24" nzMd="24">
        <div nz-row>
          <div nz-col nzSm="8" nzMd="8">
            <nz-form-item><label nz-checkbox>Chọn phân hệ là GDHN</label></nz-form-item>
          </div>
          <div nz-col nzSm="8" nzMd="8">
            <nz-form-item><label nz-checkbox>Chọn nhập số phòng hỗ trợ là GDHN</label></nz-form-item>
          </div>
          <div nz-col nzSm="8" nzMd="8">
            <nz-form-item><label nz-checkbox>Chọn cấp trực thuộc là GDHN</label></nz-form-item>
          </div>
        </div>
      </div> -->
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" type="submit">Lưu &
        Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" type="submit">Sửa</button>
    </div>
  </div>
</form>
